var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.390625,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#C9EDB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8125 20.3906C7.8125 13.6597 13.269 8.20312 20 8.20312C26.731 8.20312 32.1875 13.6597 32.1875 20.3906C32.1875 27.1216 26.731 32.5781 20 32.5781C13.269 32.5781 7.8125 27.1216 7.8125 20.3906ZM24.5129 18.123C24.8138 17.7017 24.7162 17.1162 24.2949 16.8153C23.8736 16.5143 23.2881 16.6119 22.9871 17.0332L18.9429 22.6952L16.9129 20.6652C16.5468 20.2991 15.9532 20.2991 15.5871 20.6652C15.221 21.0313 15.221 21.6249 15.5871 21.991L18.3996 24.8035C18.5945 24.9984 18.8652 25.0977 19.1398 25.0749C19.4145 25.0522 19.6652 24.9098 19.8254 24.6855L24.5129 18.123Z",
    stroke: "#3A8B12",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.7b0f7371cbe66fde681ee38c0d8b054f.svg";
export { ForwardRef as ReactComponent };